import store from 'store'
import { setUploaderOptions } from 'actions/shared'

export default (props) => {
  store.dispatch(setUploaderOptions(props.uploaderOptions))
  return null
}
